var map = {
	"./arrow_down.svg": "b8b5",
	"./circle.svg": "4477",
	"./heart.svg": "5134",
	"./heart_filled.svg": "a9fb",
	"./rounded.svg": "25e6",
	"./square.svg": "5916",
	"./star.svg": "433d",
	"./star_filled.svg": "5d2b",
	"./thumbs_up.svg": "c771",
	"./thumbs_up_filled.svg": "5766",
	"./transparent-circle.svg": "da38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bc9";